package dev.maiklutz.ready4radio.pages

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.silk.components.text.SpanText

@Page
@Composable
fun HomePage() {
    SpanText("Ready4Radio")
}
